import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import style from "../admin.module.scss";

interface card {
  icon?: any;
  cardTitle: string;
  counter: number;
  buttonText: string;
  url: string;
}

const AdminCard = ({ icon, cardTitle, counter, buttonText, url }: card) => {
  return (
    <>
      <div
        className="w-[350px] rounded-2xl shadow-xl
                overflow-hidden flex flex-col font-roboto p-6 bg-gray-100"
      >
        <div className="flex flex-row items-center mb-3">
          <div className="font-bold bg-[#3786AA] p-8 text-white rounded-full w-8 h-8 flex items-center justify-center mr-4">
            <span>{icon}</span>
          </div>
          <div>
            <h5 className="font-semibold text-xl text-gray-800">{cardTitle}</h5>
            <p className="text-lg font-bold mt-2 text-gray-700">{counter}</p>
          </div>
        </div>

        <button
          className="mt-4 py-2 px-8 text-white rounded-lg w-full 
                h-10 flex justify-center items-center text-sm
               bg-[#3786AA]"
        >
          {buttonText}
        </button>
      </div>
    </>
  );
};

export default AdminCard;
